import request from 'yeself-common/utils/RequestUtils';

import EnvironmentConfiguration from 'yeself-client-common/EnvironmentConfiguration';

export const fetchAdminOrganizationsListService = (): ReturnType<typeof request.get> =>
    request.get(
        `${EnvironmentConfiguration.API_IDENTITY_SLUG}/manage/organizations/view/administrator-of`
    );

export const fetchMemberOrganizationsListService = (): ReturnType<typeof request.get> =>
    request.get(
        `${EnvironmentConfiguration.API_IDENTITY_SLUG}/manage/organizations/view/member-of`
    );
